import React from "react";
import { Container, Row, Col } from "reactstrap";

const ApproachSection = ({ data }) => {
    if (!data) return null;

    return (
        <section className="approach-section py-5">
            <Container>
                {/* Header */}
                <div className="sec-head">
                    <p className="eyebrow">{data.sectionTitle}</p>
                    <h2 className="section-title">{data.heading}</h2>
                    <p className="section-desc">{data.description}</p>
                </div>

                {/* Timeline */}
                <div className="timeline-wrapper position-relative">
                    <div className="timeline-line" />

                    <Row className="justify-content-between text-center">
                        {data.steps.map((item, index) => (
                            <Col key={index} lg="2" md="4" sm="6" xs="12" className="p-step mb-4">

                                {/* Circle */}
                                <div className="timeline-step">
                                    <div className="circle">{item.step}</div>
                                </div>

                                {/* Content */}
                                <h3 className="step-title mt-3">{item.title}</h3>
                                <p className="step-desc">{item.description}</p>
                            </Col>
                        ))}
                    </Row>
                </div>
            </Container>
        </section>
    );
};

export default ApproachSection;